import {
  DeleteOutlined,
  InboxOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import { Form, Typography, Upload } from "antd";
import { imgNameFormatter as imgName } from "../../../utils";

const SingleUploadPackageImage = ({
  packageType,
  fileList,
  setFileList,
  setIsDisabledButton,
}: any) => {
  return (
    <div>
      <Typography className="font-bold mb-2">PAKET {packageType}</Typography>

      {!fileList?.id && (
        <Form.Item
          name={`coverimage${packageType}`}
          rules={[
            {
              required: true,
              message: "Dodaj sliku događaja!",
            },
          ]}
        >
          <Upload
            name="coverImage"
            listType="text"
            multiple={false}
            maxCount={1}
            beforeUpload={() => false}
            accept=".jpg, .png"
            className=" rounded-md mt-2 sticky"
            fileList={fileList}
            onChange={({ fileList }) => setFileList(fileList)}
          >
            {fileList.length === 0 && (
              <div className="bg-custom-gray-100 border border-dashed border-custom-gray-400 h-[150px]  rounded-sm flex flex-col items-center justify-center gap-4 cursor-pointer">
                <InboxOutlined className="text-4xl text-[#1890FF]" />
                <Typography className="text-base text-center px-16 xl:px-12 2xl:px-24">
                  Klikni ili prevuci sliku za upload
                </Typography>
              </div>
            )}
          </Upload>
        </Form.Item>
      )}

      {fileList?.id && (
        <div className="flex py-1 w-full bg-custom-gray-100 border border-custom-gray-400 rounded mb-8">
          <PaperClipOutlined className="w-4 mx-1" />
          <div className="flex justify-between items-center w-[calc(100%-30px)]">
            <a
              className="w-2/3 truncate"
              href={fileList?.imgUrl}
              target="_blank"
            >
              {imgName(fileList.imgUrl)}
            </a>
            <div
              className="cursor-pointer text-custom-red-900"
              onClick={() => {
                setFileList([]);
                setIsDisabledButton(false);
              }}
            >
              <DeleteOutlined />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default SingleUploadPackageImage;
